<template>
    <!-- 材料检测 -->
    <div>
        <contentIndex :initInfo="info"></contentIndex>
    </div>
</template>
<script>
import contentIndex from "./index.vue"
export default {
    components: {
        contentIndex
    },
    data() {
        return {
            info: {
                type: 2,
                testTypeList: [
                    { dictLabel: "全部", dictValue: '' },
                    { dictLabel: "组织形貌", dictValue: '组织形貌' },
                    { dictLabel: "成分含量", dictValue: '成分含量' },
                    { dictLabel: "化学结构", dictValue: '化学结构' },
                    { dictLabel: "物理性能", dictValue: '物理性能' },
                    { dictLabel: "力学性能", dictValue: '力学性能' },
                    { dictLabel: "光电磁声", dictValue: '光电磁声' },
                    { dictLabel: "冷门测试", dictValue: '冷门测试' },
                    { dictLabel: "可靠性测试", dictValue: '可靠性测试' },
                ],
            }
        }
    }
}
</script>